export const MENU_NAV_HEIGHT = 65;
